import React from 'react';
import './ResearchCards.css';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function ResearchCard({ title, pictureSrc, content, buttonText, linkTo, targetSection }) {

  return (
    <div className="cards-research">
      {/* Make the image + title the navigable area */}
      <Link to={`/content/${targetSection}`} className="card-link-research">
        <div>
          <img
            src={pictureSrc && pictureSrc.startsWith('http') ? pictureSrc : process.env.PUBLIC_URL + "/images/" + pictureSrc}
            alt={title}
            className="card-picture-research"
          />
        </div>
        <h2 className="card-title-research">{title}</h2>
      </Link>

      {/* Render YAML Markdown here so [PyPI](...) becomes a real link */}
      <div className="card-content-research">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>

      {/* Optional: keep your scroll button if you want */}
      {/* <ScrollButton buttonText={buttonText || "Know More"} targetSection={targetSection} /> */}
    </div>
  );
}

export default ResearchCard;
